import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './rootReducer';
import { TDialogTypeState } from './slices/dialogsSlice';
import { ISelectedYachtState } from './slices/yachtSlice';

export interface IGlobalStoreReducers {
  dialog: TDialogTypeState;
  selectedYacht: ISelectedYachtState;
}

export const globalStore = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
    // preloadedState,
});

export type RootState = ReturnType<typeof globalStore.getState>;
export type AppDispatch = typeof globalStore.dispatch;
